var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"search"},[_c('el-input',{attrs:{"placeholder":"Suche ..."},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_c('MailTable',{attrs:{"items":_vm.items,"loading":_vm.loading},on:{"loadmore":_vm.loadmore}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }